'use strict';

module.exports = require('./hyphenated-en-us.cjs.js');
